import { LaPrairiePortalFilters } from 'components/constants/Constants';
import { FilterOption } from 'types/Search';
import SearchFilterItem from '../SearchFilterItem/SearchFilterItem';

/**
 * @deprecated Will be removed after LaPrairie migration
 */
const CustomFilters: React.FC = () => {
  return (
    <div className="search-filters search-filters-custom unset-height">
      <div className="search-filters-header">
        <div className="search-filters-header-title">CUSTOM FILTERS</div>
      </div>

      {LaPrairiePortalFilters.map((option: FilterOption) => {
        return <SearchFilterItem key={option.key} option={option} />;
      })}
    </div>
  );
};

export default CustomFilters;
